import { clsx } from 'clsx';
import { Box, Tooltip } from '@material-ui/core';

import CustomButton from '../common/buttons/custom-button';

import useStyles from './styles';
import { CheckCode } from '../main-kanban-card/components/check-code';
import { Alert } from '@material-ui/lab';
import { ExpandMore } from '@material-ui/icons';
import { OrderDeliveryDetail } from '../../features/order/delivery-detail';
import { ORDER_READY_ADOPTION } from 'components/main-kanban-card/domain/mainKanbanCard.const';
import { storeAuditService } from 'features/order/store-audit/infra';
import { StoreAuditAlert } from 'features/order/store-audit/components';
import OrdersUtils from 'utils/OrdersUtils';

export function KanbanCardFooter(props) {
  const {
    classes = {},
    buttonText = '',
    footerText = '',
    secondaryButtonText = '',
    onClick = () => {},
    onClickSecondaryButton = () => {},
    productConfirmationCode = null,
    productConfirmationCodeLabel = '',
    orderId = null,
    storeId = null,
    orderState = null,
    isOpenOrderDeliveryDetails = false,
    onToggleOpenOrderDeliveryDetails = () => {},
    completeOrderDetailText = '',
    showOrderDeliveryDetails = false,
    hasOrderDeliveryDetailMessage = false,
    isMandatory = false,
    hasTurboUrgency,
    showOrderReadyAdoption,
    showRTHandoffBtn = false,
    showMainBtn = false,
    isOrderReadyButtonEnabled,
    orderReadyButtonReadyText,
    currentOrder,
  } = props;

  const _classes = useStyles({
    showOrderDeliveryDetails,
    hasOrderDeliveryDetailMessage,
  });

  const _hasDefectRateReport = storeAuditService.getOrderAudit(orderId) != null;
  const _storeAudit = storeAuditService.getOrderAudit(orderId);
  const _isReadyAndPacked = OrdersUtils.isReadyAndPacked(orderState);
  const _showStoreAuditAlert =
    _hasDefectRateReport && _isReadyAndPacked && !_storeAudit?.isAllChecked;

  if (showOrderDeliveryDetails) {
    return (
      <Box display='flex' flexDirection='column'>
        {!isOpenOrderDeliveryDetails && (
          <Alert
            severity='error'
            classes={{
              root: _classes.alert,
              ico: _classes.alertIcon,
              message: _classes.alertMessage,
            }}
            action={<ExpandMore />}
            onClick={onToggleOpenOrderDeliveryDetails}
          >
            <span>{completeOrderDetailText}</span>
          </Alert>
        )}
        {isOpenOrderDeliveryDetails && (
          <OrderDeliveryDetail
            orderId={orderId}
            storeId={storeId}
            orderState={orderState}
            onClose={onToggleOpenOrderDeliveryDetails}
            isInKanban
            isMandatory={isMandatory}
            hasDeliveryDetailMessage={hasOrderDeliveryDetailMessage}
            hasDefectRate={_hasDefectRateReport}
          />
        )}
      </Box>
    );
  }

  return (
    <>
      {(!!footerText ||
        !!buttonText ||
        !!secondaryButtonText ||
        !!productConfirmationCode) && (
        <div>
          {_showStoreAuditAlert && (
            <div style={{ marginBottom: '0.5rem' }}>
              <StoreAuditAlert orderId={orderId} />
            </div>
          )}
          <div className={clsx(_classes.root, classes?.root)}>
            {!!footerText && (
              <div className={clsx(_classes.footerText, classes?.footerText)}>
                {footerText}
              </div>
            )}
            {showMainBtn && (
              <OrderReadyButtonTooltipWrapper
                condition={!isOrderReadyButtonEnabled}
                wrapper={children => (
                  <Tooltip
                    classes={{ tooltip: _classes.tooltip }}
                    title={orderReadyButtonReadyText}
                    placement='left-start'
                    arrow
                  >
                    {children}
                  </Tooltip>
                )}
              >
                <Box id={`${ORDER_READY_ADOPTION}-${orderId}`}>
                  <CustomButton
                    classes={{
                      root: _classes.buttonRoot,
                      submitButton: _classes.buttonSubmitRoot,
                    }}
                    fullWidth={false}
                    onClick={async e => {
                      await onClick(e);
                    }}
                    variant='contained'
                    disabled={!isOrderReadyButtonEnabled}
                  >
                    {buttonText}
                  </CustomButton>
                </Box>
              </OrderReadyButtonTooltipWrapper>
            )}
            {!!secondaryButtonText && (
              <CustomButton
                classes={{
                  root: _classes.secondaryButtonRoot,
                  submitButton: _classes.secondaryButtonSubmitRoot,
                }}
                fullWidth={false}
                onClick={async e => {
                  await onClickSecondaryButton(e);
                }}
                variant='text'
              >
                {secondaryButtonText}
              </CustomButton>
            )}
            {showRTHandoffBtn && (
              <CheckCode
                label={productConfirmationCodeLabel}
                code={productConfirmationCode}
                hasTurboUrgency={hasTurboUrgency}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
}

function OrderReadyButtonTooltipWrapper({ condition, wrapper, children }) {
  return condition ? wrapper(children) : children;
}
